import React, { Component } from "react";
import "./errorBoundary.css";
class ErrorBondry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div class="box">
          <br />
          <br />
          <img
            src="https://cdn.iconscout.com/icon/free/png-512/dizzy-face-cross-error-emoji-37675.png"
            width="70"
            class="center"
          />
          <h2>Oh No</h2>
          <h3>Something Went Wrong</h3>
          <h3>
            <button
              class="btn success"
              onClick={() => (window.location.href = "/dashboard")}
            >
              Go to Home
            </button>
          </h3>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBondry;
